module.exports = __webpack_public_path__ + "img/logo.662a4c78.png";